import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Grid, Typography } from "@mui/material";
import {
  addBillingConsolidatedInvoice,
  addBillingRequestApprovalLink,
  generateBillSelfConsolidatedInvoice,
} from "redux/actions/BillingAction";
import useModal from "hooks/useModal";
import CommonButton from "components/commonButton/CommonButton";
import ConfirmAndLinkModel from "components/commonConfirmAndLinkModel/ConfirmAndLinkModel";
import { fetchCompanyDetails } from "redux/actions/companyAction";

function BillGenerateLink({
  selectedCheckRows,
  accessForGenerate,
  billingFilter,
  setSelectedCheckRows,
  setSelectAllChecked,
  billingListpayloadData,
  tableValue,
  billingType,
}) {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [buttonClick, setButtonClick] = useState(false);
  const [totalAmount, setTotalAmount] = useState({ id: [], amount: "0" });

  // ── STATE FOR PAYMENT LINK MODAL ──
  const [consolidatedInvoiceId, setConsolidatedInvoiceId] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentLinkModalOpen, setPaymentLinkModalOpen] = useState(false);

  const companyName = searchParams.get("companyName");
  const companyID = searchParams.get("companyId");

  useEffect(() => {
    if (selectedCheckRows && selectedCheckRows.length > 0) {
      let amount = "0";
      let ids = [];
      selectedCheckRows?.forEach((object) => {
        ids.push(object?.id);
        amount = Number(amount) + Number(object?.price);
      });
      setTotalAmount({ ...totalAmount, id: ids, amount: amount });

      // ── EXTRACT CONSOLIDATED INVOICE ID & PAYMENT STATUS ──
      const firstRow = selectedCheckRows[0];
      setConsolidatedInvoiceId(firstRow?.consolidatedInvoiceId || firstRow?.id);
      setPaymentStatus(firstRow?.paymentStatus || "Unpaid"); // Default to Unpaid if not provided
    }
  }, [selectedCheckRows]);

  const { open, toggle } = useModal();

  const handleLinkModel = () => {
    const paylaod = {
      invoiceIds: totalAmount?.id,
      companyId: billingFilter?.parentCompanyName?.value,
    };

    if (selectedCheckRows?.length && !buttonClick) {
      setButtonClick(true);
      if (tableValue === "approvalForCharge") {
        if (billingType === "billToCreditCard") {
          dispatch(
            generateBillSelfConsolidatedInvoice(
              {
                invoiceIds: totalAmount?.id,
                companyId: billingFilter?.parentCompanyName?.value,
                employeeId: billingFilter?.employee?.value,
                cityId: billingFilter?.city?.value,
              },
              billingListpayloadData,
              handleTotalAmount,
            ),
          );
        } else {
          dispatch(
            addBillingConsolidatedInvoice(
              paylaod,
              billingListpayloadData,
              handleTotalAmount,
            ),
          );
        }
      } else if (tableValue === "charged") {
        // ── NEW: Open Payment Link Modal directly ──
        setPaymentLinkModalOpen(true);
        setButtonClick(false);
      } else {
        dispatch(fetchCompanyDetails({ id: companyID }));
        dispatch(
          addBillingRequestApprovalLink({ ...paylaod, link: true }, toggle),
        );
      }
    }
  };

  const handleTotalAmount = () => {
    setSelectedCheckRows([]);
    setSelectAllChecked(false);
    setTotalAmount({ ...totalAmount, id: "", amount: "00" });
  };

  const btnText = (status) => {
    switch (status) {
      case "pendingApproval":
        return "Generate Link";
      case "approvalForCharge":
        return "Generate Final Invoice";
      case "charged":
        return "Payment Options"; // Changed text
      default:
        return "";
    }
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="mb20 ptb20 bgTransperent"
      >
        <Grid item md={9} sm={12}>
          <Typography className="colorPrimary fw600 font20">
            Total Amount{" "}
            <span className="ml40">
              {" "}
              ₹ {Number(totalAmount?.amount).toFixed(2)}
            </span>
          </Typography>
          <Typography className="colorGrey font18 fw400">
            Note :- All the invoice contain their respective toll & parking
            details.
          </Typography>
        </Grid>
        <Grid item md={3} sm={12} className="flexend">
          {accessForGenerate && (
            <CommonButton
              name={btnText(tableValue)}
              type="submit"
              btnClass="btnSm"
              disabled={!selectedCheckRows?.length || buttonClick}
              onClick={handleLinkModel}
            />
          )}
        </Grid>
      </Grid>

      {open && (
        <ConfirmAndLinkModel
          open={open}
          setTotalAmount={setTotalAmount}
          setSelectedCheckRows={setSelectedCheckRows}
          setSelectAllChecked={setSelectAllChecked}
          billingListpayloadData={billingListpayloadData}
          handleClose={toggle}
          selectType="billLink"
          companyName={companyName}
          totalAmount={totalAmount}
          billingFilter={billingFilter}
        />
      )}

      {/* ── NEW: PAYMENT LINK DISPLAY MODAL ── */}
      {paymentLinkModalOpen && consolidatedInvoiceId && (
        <ConfirmAndLinkModel
          open={paymentLinkModalOpen}
          handleClose={() => {
            setPaymentLinkModalOpen(false);
            handleTotalAmount();
          }}
          selectType="paymentLink"
          companyName={companyName}
          totalAmount={totalAmount}
          billingFilter={billingFilter}
          consolidatedInvoiceId={consolidatedInvoiceId}
          paymentStatus={paymentStatus}
        />
      )}
    </>
  );
}

export default BillGenerateLink;
